import { NSARouterMakerResult } from "namirasoft-account-react";
import { ClassifierClassRow, NamirasoftInferenceMetaDatabase } from "namirasoft-inference";
import { BaseColumnFormatter, NSColumn, NSTable, StringFormatter, TableColumnInfo } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ClassifierClassesViewProps extends NSARouterMakerResult, InferenceRouterProps
{
	classifier_id: string;
	rows: ClassifierClassRow[];
}

interface ClassifierClassesViewState
{
	columns: TableColumnInfo[] | null;
}

export default class ClassifierClassesView extends Component<ClassifierClassesViewProps, ClassifierClassesViewState>
{
	override state: ClassifierClassesViewState = { columns: null };

	private Table_Ref = createRef<NSTable<ClassifierClassRow>>();

	override componentDidMount(): void { this.setState({ columns: this.buildColumns() }); }

	override componentDidUpdate(prev: ClassifierClassesViewProps): void
	{
		if (prev.classifier_id !== this.props.classifier_id || prev.rows !== this.props.rows)
			this.Table_Ref.current?.reload(null, null);
	}

	private buildColumns(): TableColumnInfo[]
	{
		let inference = new NamirasoftInferenceMetaDatabase(this.props.account.token_manager, console.error);
		let table = inference.tables.classifier_class;
		return [
			BaseColumnFormatter.getColumn(table.columns.name, new StringFormatter()),
			BaseColumnFormatter.getColumn(table.columns.description, new StringFormatter()),
		];
	}

	private getRows = async (): Promise<{ rows: ClassifierClassRow[], count: number }> =>
	{
		let rows = this.props.rows ?? [];
		return { rows, count: rows.length };
	};

	override render()
	{
		let { columns } = this.state;
		return (
			<NSColumn style={{ width: "100%", marginTop: 16, gap: 8 }}>
				<div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%", flexGrow: 1 }}>
					<NSTable<ClassifierClassRow>
						ref={this.Table_Ref}
						name="classifier-classes"
						checkbox={false}
						columns={columns ?? this.buildColumns()}
						getRows={this.getRows}
						getRowKey={(row) => row.value.id}
						ui={{ pagination: false, button_panel: false }}
					/>
				</div>
			</NSColumn>
		);
	}
}